import { useState } from "react"
import { useNavigate } from "react-router-dom"

import ExpoModal from "../navigation/ExpoModal"

function AdminOrderItem({ item, expo }) {
  const [ expoModal, setExpoModal ] = useState(false)
  const navigate = useNavigate()

  return (
    <div className="ad-order-item">
      <div className="ad-order-left" onClick={()=> navigate(`/order/admin/${item.order_id}/${item.id}`)}>
        <span>Order #: {item.id}</span>
        <span>Order For: {item.display_name}</span>
      </div>

      <div className="ad-order-right" onClick={() => setExpoModal(true)}>
        <div>EXPO</div>
      </div>

      {expoModal ?
        <ExpoModal order_id={item.order_id} expo={expo} onClose={() => setExpoModal(false)} />
      : null}
    </div>
  )
}

export default AdminOrderItem
